import { Text } from '@postenbring/hedwig-react'
import './header.scss';

export const Header = ({ size, headerText, displaySize, textColor, marginBottom, marginTop }) => {

    let className = 'kp-header';
    marginBottom ? className += ' ' + marginBottom : '';
    marginTop ? className += ' ' + marginTop : '';
    textColor ? className += ' ' + textColor : '';

    return (
        <Text
            variant={displaySize}
            as={size}
            className={className}
        >{headerText}</Text>
    )
}

